import { GameSessionStatus } from "@/graphql/generated/operations";

export type GameTileStatus = "not-started" | "in-progress" | "completed";

// The status a game's tile in Grow · Play shows, from the caller's sessions.
// An open session wins: that is the play the tile leads back into. Otherwise
// one completed session is enough, even if a later one was abandoned or
// expired, because what it wrote (the favourites) still stands.
export function gameTileStatus(
  sessions: readonly { gameKey: string; status: GameSessionStatus }[],
  gameKey: string,
): GameTileStatus {
  const own = sessions.filter((session) => session.gameKey === gameKey);
  if (own.some((session) => session.status === GameSessionStatus.InProgress)) return "in-progress";
  if (own.some((session) => session.status === GameSessionStatus.Completed)) return "completed";
  return "not-started";
}

// How far a group of games is: the games with a completed session. The group
// tile then reads it like a questionnaire group reads its answered parts.
export function gameGroupProgress(
  sessions: readonly { gameKey: string; status: GameSessionStatus }[],
  gameKeys: readonly string[],
): { done: number; total: number } {
  const done = gameKeys.filter((key) => gameTileStatus(sessions, key) === "completed").length;
  return { done, total: gameKeys.length };
}
